var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-container"},[_c('span',{staticClass:"fadeTextIn",style:({
      animationDuration: _vm.animDuration + 's',
      animationDelay: _vm.animDelay + 's',
    }),domProps:{"innerHTML":_vm._s(_vm.data ? _vm.data[0].label : '')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }